// Invitation API - for accepting team invitations
import { request } from "./base";

export const invitationApi = {
	async previewInvitation(
		token: string,
		options?: { signal?: AbortSignal },
	) {
		return request<{
			email: string;
			role: string;
			proName: string;
			expiresAt: string;
			accountExists: boolean;
		}>(`/api/invitations/${token}/preview`, { signal: options?.signal });
	},

	async getInvitation(token: string) {
		return request<{
			id: number;
			email: string;
			role: string;
			pro: { id: string; businessName: string } | null;
			invitedBy: { id: string; name: string } | null;
			expiresAt: string;
		}>(`/api/invitations/${token}`);
	},

	async verifySignup(token: string, email: string) {
		return request<{ verified: boolean }>(`/api/invitations/${token}/verify-signup`, {
			method: "POST",
			body: { email },
		});
	},

	async acceptInvitation(token: string) {
		return request<{
			message: string;
			role: string;
			pro: { id: string; businessName: string } | null;
		}>(`/api/invitations/${token}/accept`, {
			method: "POST",
		});
	},
};
